<ng-container *transloco="let t;">
    <div class="form-group mb-1 d-flex justify-content-between align-items-center pt-25">
        <label class="col-form-label p-0" for="name">
            {{t("Document key text (Template/Document - section) - Document key")}}
            <i
                class="feather icon-alert-circle ms-25"
                placement="top"
                container="body"
                placement="auto"
                [autoClose]="true"
                triggers="hover"
                [ngbTooltip]='t("Password - label (general) - Password")'
            ></i>
        </label>
        <div class="custom-control custom-control-primary custom-switch">
            <input type="checkbox" class="custom-control-input" id="documentKey" [disabled]="!canEdit" [(ngModel)]="_field.value" (change)="onDocumentKeyChange($event.target.checked)" />
            <label class="custom-control-label" for="documentKey"></label>
        </div>
    </div>

    <div class="form-group mb-1" *ngIf="formGroup.get('document_key').value">
        <ng-select [items]="documentKeyType" bindLabel="name" bindValue="value" [clearable]="false" [disabled]="!canEdit" [placeholder]='t("Document key type placeholder text (Template/Document - section) - Select key type")' [ngModel]="formGroup.get('dk_type')?.value" (change)="onDocumentKeyTypeChange($event)"> </ng-select>
    </div>

    <div *ngIf="formGroup.get('document_key').value && formGroup.get('dk_type').value === 'password'" class="document-key-box">
            <div class="form-group mb-1">
                <input type="text" class="form-control" id="dk_password" [disabled]="!canEdit" [ngModel]="formGroup.get('dk_password')?.value" [placeholder]='t("Password - label (general) - Password")' (blur)="onDKPasswordChange($event.target.value)" (keyup.enter)="onDKPasswordChange($event.target.value)" />
            </div>

            <div class="form-group mb-1">
                <input
                    type="text"
                    class="form-control"
                    id="dk_password_hint" [(ngModel)]="_field.dk_password_hint"
                    [disabled]="!canEdit"
                    [placeholder]='t("Password Hint text (Template/Document - section) - Password Hint")'
                    (blur)="onDKPasswordHintChange($event.target.value)"
                    (keyup.enter)="onDKPasswordHintChange($event.target.value)"
                />
            </div>

            <div class="form-group mb-2">
                <div class="custom-control custom-checkbox">
                    <input type="checkbox" class="custom-control-input" id="SendPasswordViaSMS" [disabled]="!canEdit" [(ngModel)]="field.dk_send_via_sms" (change)="onDKSendViaSMSChange($event.target.checked)" />
                    <label class="custom-control-label" for="SendPasswordViaSMS">{{t("Send Password Via SMS text (Template/Document - section ) - Send Password Via SMS")}}</label>
                </div>
            </div>
        </div>
</ng-container>